import React from 'react';
import { Home, Building2, Sofa, HardHat, Trees, Trash2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Services = () => {
  const services = [
    {
      icon: Home,
      title: 'Residential Junk Removal',
      description: 'Clear out your home with ease. From old furniture to appliances, we handle all residential junk removal needs.',
      image: 'https://images.unsplash.com/photo-1760441981883-53f65ff71b88?w=800&q=80'
    },
    {
      icon: Building2,
      title: 'Commercial Junk Removal',
      description: 'Keep your business space clean and organized. We offer efficient commercial junk removal for offices, retail spaces, and warehouses.',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80'
    },
    {
      icon: Sofa,
      title: 'Furniture & Appliance Removal',
      description: 'Heavy lifting? No problem. We safely remove and dispose of old furniture, refrigerators, washers, dryers, and more.',
      image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=80'
    },
    {
      icon: HardHat,
      title: 'Construction & Renovation Debris',
      description: 'Post-renovation cleanup made simple. We haul away drywall, lumber, tiles, and all construction materials.',
      image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80'
    },
    {
      icon: Trees,
      title: 'Yard Waste & Cleanouts',
      description: 'Seasonal cleanup or major yard overhaul? We remove branches, leaves, soil, and all types of yard waste.',
      image: 'https://customer-assets.emergentagent.com/job_haul-away-pro/artifacts/uasm3vun_dirtt.jpg'
    },
    {
      icon: Trash2,
      title: 'Estate & Garage Cleanouts',
      description: 'Full property cleanouts for estates, garages, basements, and attics. We handle everything from sorting to disposal.',
      image: 'https://images.unsplash.com/photo-1647299852821-40401c0b0976?w=800&q=80'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We handle all types of junk removal for residential and commercial clients in Hamilton and surrounding areas.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card key={index} className="overflow-hidden border-2 border-gray-100 hover:border-emerald-400 hover:shadow-xl transition-all duration-300 group">
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 bg-emerald-600 p-3 rounded-lg">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;